export default class Search {
  constructor() {
    this.init();
  }

  init() {
    if ( !document.querySelector('.js-search-button') ) return;
    this.bindEvents();
  }

  bindEvents() {
    document.querySelector('.js-search-button').addEventListener('click', this.clickSearchButton);
  }

  clickSearchButton() {
    const checkInDateString = document.querySelector('.js-stay-year').value + '/' + document.querySelector('.js-stay-month').value + '/' + document.querySelector('.js-stay-day').value;

    let checkOutDateObject = new Date(checkInDateString);
    const numDays = Number(document.querySelector('.js-num-days').value);

    checkOutDateObject.setDate(checkOutDateObject.getDate() + numDays);

    const checkOutYear = checkOutDateObject.getFullYear();
    const checkOutMonth = checkOutDateObject.getMonth() + 1;
    const checkOutDay = checkOutDateObject.getDate();

    const checkOutDateArray = {
      chkout_yy : checkOutYear,
      chkout_mm : ('0' + checkOutMonth).slice(-2),
      chkout_dd : ('0' + checkOutDay).slice(-2)
    }

    console.log(checkOutDateArray);

    for (const key in checkOutDateArray) {

      let request = document.createElement('input');

      request.type = 'hidden';
      request.name = key;
      request.value = checkOutDateArray[key];

      document.querySelector('.js-search-form').appendChild(request);
    }

    document.querySelector('.js-search-form').submit();
  }
};
